import { useMemo } from 'react';

import { PromoRateCodeIssue } from '@features/rates';
import { useTranslations } from '@lang';

export type RateCodeNotice = {
  title: string;
  subtitle: string;
};

export default function useRateCodeNotice(
  rateCode?: string,
  issue?: PromoRateCodeIssue
): RateCodeNotice | undefined {
  const { t } = useTranslations();

  return useMemo(() => {
    if (!rateCode || !issue) {
      return undefined;
    }

    if (issue === 'unknown') {
      return {
        title: t('room.unknownRateCodeHeader'),
        subtitle: t('room.unknownRateCodeInfo', { rateCode }),
      };
    }

    return {
      title: t('room.unavailableRateCodeHeader'),
      subtitle: t('room.unavailableRateCodeInfo', { rateCode }),
    };
  }, [rateCode, issue, t]);
}
